import React from "react";
import "./listOfAwards.scss";

//Imagens:
import ImgAwardOne from "../../../assets/awards/awardOne.png";
import ImgAwardTwo from "../../../assets/awards/awardTwo.png";
import ImgAwardThree from "../../../assets/awards/awardThree.png";
import ImgAwardFour from "../../../assets/awards/awardFour.png";
import ImgAwardFive from "../../../assets/awards/awardFive.png";

function ListOfAwards() {
  return (
    <div className="container-list-of-awards">

     <div className="column-list-of-awards-one">
            <img src={ImgAwardOne} alt="" />
     </div>

     <div className="column-list-of-awards-two">
        <div className="column-one">
            <img src={ImgAwardTwo} alt="" />
            <img src={ImgAwardThree} alt="" />
        </div>
        <div className="column-two">
            <img src={ImgAwardFour} alt="" />
            <img src={ImgAwardFive} alt="" />
        </div>
     </div>

    </div>
  );
}

export default ListOfAwards;
